/**
 * Utility functions for handling dates and chronology preferences
 */

/**
 * Resolves the primary date to display based on user chronology preferences
 * Returns the active date and the list of alternative dates
 */
export function resolveDisplayDate(
    primaryDate: DateProposal,
    alternativeDates: DateProposal[] | undefined,
    preferredChronology: BiblicalChronology | undefined
): { activeDate: DateProposal; alternatives: DateProposal[] } {
    const allDates = [primaryDate, ...(alternativeDates || [])];

    if (allDates.length <= 1) {
        return { activeDate: primaryDate, alternatives: alternativeDates || [] };
    }

    // Define priority order based on preference
    let priority: BiblicalChronology[];
    
    if (preferredChronology === 'Archaeological') {
        priority = ['Archaeological', 'Textual', 'Consensus', 'Critical'];
    } else if (preferredChronology === 'Textual') {
        priority = ['Textual', 'Archaeological', 'Consensus', 'Critical'];
    } else if (preferredChronology === 'Critical') {
        priority = ['Critical', 'Consensus', 'Archaeological', 'Textual'];
    } else {
        // No preference OR preference is 'Consensus'
        // Default to Consensus first, then Textual as the most common baseline
        priority = ['Consensus', 'Textual', 'Archaeological', 'Critical'];
    }

    // Find the best matching date based on priority
    for (const chrono of priority) {
        const match = allDates.find(d => d.chronology === chrono);
        if (match) {
            return {
                activeDate: match,
                alternatives: allDates.filter(d => d !== match)
            };
        }
    }

    // Fallback to primary date (shouldn't really be reached if all types are in priority list)
    return { activeDate: primaryDate, alternatives: alternativeDates || [] };
}
